import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import classnames from "classnames";

import noop from "shared/util/noop";
import CloseIcon from "shared/components/svgs/close_x.svg";

if (process.env.PLATFORM === "desktop") {
	require("./Toast.desktop.scss");
} else {
	require("./Toast.mobile.scss");
}

const Toast = ({
	image,
	header,
	subHeader,
	onClose,
	shouldAnimate,
	linkTo,
	className,
	shouldCloseOnClick,
	onClick,
}) => {
	const onLinkClose = shouldCloseOnClick ? onClose : noop;

	return (
		<div
			className={classnames("toast", {
				"toast-slide": shouldAnimate,
				[className]: className,
			})}
		>
			<Link
				to={linkTo}
				className="toast-link"
				onClick={() => {
					onClick();
					onLinkClose();
				}}
			>
				<div className="toast-image-container">
					{image}
				</div>
				<div className="toast-text">
					<span className="toast-text-header">{header}</span>
					<span className="toast-text-subheader">{subHeader}</span>
				</div>
			</Link>
			<button
				type="button"
				onClick={onClose}
				className="toast-close-button"
			>
				<CloseIcon
					height={25}
					width={25}
				/>
			</button>
		</div>
	);
};

Toast.propTypes = {
	image: PropTypes.node.isRequired,
	header: PropTypes.string.isRequired,
	subHeader: PropTypes.string.isRequired,
	onClose: PropTypes.func.isRequired,
	shouldAnimate: PropTypes.bool,
	linkTo: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.object,
	]).isRequired,
	className: PropTypes.string,
	shouldCloseOnClick: PropTypes.bool,
	onClick: PropTypes.func,
};

Toast.defaultProps = {
	shouldAnimate: false,
	className: null,
	shouldCloseOnClick: true,
	onClick: () => {},
};

export default Toast;



// WEBPACK FOOTER //
// ./src/shared/components/Toast/Toast.jsx